import { CSS, StyleProps } from "@shared/primitive-components"

export const headingsWrapper = (props: StyleProps) => ({
  lineHeight: `22px`,
  fontSize: props.theme.fontSize.caption,
  color: props.theme.palette.coal.dark,
  borderBottom: `0.25px solid ${props.theme.palette.grey.light}`,
})

export const makeHeadingColumnStyle = (margin?: number) => () => ({
  flexGrow: 1,
  marginLeft: margin ? `${margin}vw` : undefined,
})

export const rowWrap = (): CSS => ({
  flexDirection: `row`,
  alignItems: `start`,
  marginTop: `2vh`,
})

export const makeCellWrapStyle = (isLast?: boolean) => () => ({
  marginRight: isLast ? undefined : `2vw`,
  flexGrow: 1,
})
